const mutations = {
  setId(state: any, id: string) {
    state.id = id
  },

  getArticleData(state: any, data: any) {
    state.data = data
  },

  setRelativedGoods(state: any, data: any) {
    state.relativedGoods = data
  },

  setCommentData(state: any, data: any) {
    state.commentData = data
  },

  updatePraiseNum(state: any, payload: any) {
    const { list } = state.commentData
    if (payload.isReply) {
      let curV = list.find((v: any) => v.comment_id == payload.parentCommentId)
      let curR = curV?.reply_list.find((v: any) => v.comment_id == payload.comment_id)
      curR.praise_num = +curR.praise_num + 1
    } else {
      let curV = list.find((v: any) => v.comment_id == payload.comment_id)
      curV.praise_num = +curV.praise_num + 1
    }
  },

  setErrorTxt(state: any, payload: any) {
    state.errorTxt = payload
  },
  setMtData(state: any, data: any) {
    state.mtData = data
  },
}

export default mutations
